// AI-CONTEXT: See docs/features/deep-analysis-period.md
//
// When the deep-analysis page compares two periods, the result card renders
// its visualisation twice (ParentCompareView). Each copy portals its facts /
// participation / details into DeepAnalysisSlotsContext — without this split
// both copies would land in the SAME pane, doubled and interleaved. The page
// owns a second set of panes under `slots.B`; this picks the set for a side.

/**
 * @typedef {object} DeepAnalysisSlots
 * @property {HTMLElement|null} factsEl
 * @property {HTMLElement|null} participationEl
 * @property {HTMLElement|null} [detailsEl]
 * @property {DeepAnalysisSlots|null} [B] - Panes for the compare period
 */

/**
 * @param {DeepAnalysisSlots|null|undefined} slots - The page's slots (null outside a deep-analysis page)
 * @param {'A'|'B'} side - Which period this copy renders
 * @returns {DeepAnalysisSlots|null}
 */
const slotsForSide = (slots, side) => {
    if (!slots) return null
    return side === 'B' ? (slots.B || null) : slots
}

export default slotsForSide
